import { useEffect, useState } from "react";
const useFatcaCodeOptions = () => {
    const [fatcaCodeOptions, setFatcaCodeOptions] = useState([]);
    useEffect(() => {
        const options = [
            { value: "A", text: "A" },
            { value: "B", text: "B" },
            { value: "C", text: "C" },
            { value: "D", text: "D" },
            { value: "E", text: "E" },
            { value: "F", text: "F" },
            { value: "G", text: "G" },
            { value: "H", text: "H" },
            { value: "I", text: "I" },
            { value: "J", text: "J" },
            { value: "K", text: "K" },
            { value: "L", text: "L" },
            { value: "M", text: "M" },
        ];
        setFatcaCodeOptions(options);
    }, []);
    return fatcaCodeOptions;
};
export default useFatcaCodeOptions;
